/** Debe coincidir con Role::ADMIN_USER_ROLE_NAMES (solo módulo Admin → Usuarios). */
export const ADMIN_USER_ROLE_NAMES = ['Admin', 'Owner']

export function filterAssignableCorporateRoles(roles) {
    if (!Array.isArray(roles) || roles.length === 0) {
        return roles ?? []
    }

    if (typeof roles[0] === 'object' && roles[0] !== null) {
        return roles.filter((role) => !ADMIN_USER_ROLE_NAMES.includes(role.name))
    }

    return roles.filter((role) => !ADMIN_USER_ROLE_NAMES.includes(role))
}
